interface ServerStatus {
	updating: boolean
}

export class ServerStatusService {
	private static instance: ServerStatusService
	private isPolling = false
	private pollInterval: NodeJS.Timeout | null = null
	private statusCallback: ((status: ServerStatus) => void) | null = null
	private errorCallback: ((error: Error) => void) | null = null

	private constructor() {}

	public static getInstance(): ServerStatusService {
		if (!ServerStatusService.instance) {
			ServerStatusService.instance = new ServerStatusService()
		}
		return ServerStatusService.instance
	}

	private getStatusUrl(): string {
		if (
			typeof window === 'undefined' ||
			(typeof window !== 'undefined' &&
				window.location.hostname.includes('localhost'))
		) {
			return ''
		}

		// Use current domain for status endpoint
		const protocol = window.location.protocol
		const hostname = window.location.hostname

		return `${protocol}//${hostname}/status`
	}

	private async fetchStatus(): Promise<ServerStatus> {
		if (!this.getStatusUrl()) return { updating: false }
		const response = await fetch(this.getStatusUrl(), {
			method: 'GET',
			headers: {
				'X-API-Key': 'e25Ch8mirdd4SBzN7mvMZN2iAToA53',
				'Content-Type': 'application/json',
			},
		})

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`)
		}

		return response.json()
	}

	public startPolling(
		interval: number = 10000, // Default 10 seconds
		onStatusChange?: (status: ServerStatus) => void,
		onError?: (error: Error) => void
	): void {
		if (this.isPolling) {
			return
		}

		this.statusCallback = onStatusChange || null
		this.errorCallback = onError || null
		this.isPolling = true

		// Poll immediately, then at intervals
		this.poll()

		this.pollInterval = setInterval(() => {
			this.poll()
		}, interval)
	}

	public stopPolling(): void {
		if (this.pollInterval) {
			clearInterval(this.pollInterval)
			this.pollInterval = null
		}
		this.isPolling = false
		this.statusCallback = null
		this.errorCallback = null
	}

	private async poll(): Promise<void> {
		try {
			const status = await this.fetchStatus()
			if (this.statusCallback) {
				this.statusCallback(status)
			}
		} catch (error) {
			console.error('Failed to fetch server status:', error)
			if (this.errorCallback) {
				this.errorCallback(error as Error)
			}
		}
	}

	public async getStatus(): Promise<ServerStatus> {
		return this.fetchStatus()
	}
}

export const serverStatusService = ServerStatusService.getInstance()
